import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalContext } from '../../contexts/GlobalContext';
import listLanguage from '../.././lists/languages.json'
import './LanguageSelector.css'

import { Menu, MenuButton, MenuItem, MenuDivider } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import getImage from '../../useFull/getImage';

const getLabelByValue = (value) => {
    const language = listLanguage.find(lang => lang.value === value);
    return language ? language.label : '';
};

const LanguageSelector = () => {

    const { state, updateLanguage } = useContext(GlobalContext);
    const [language, setLanguage] = useState(getLabelByValue(state.language));
    const [languages, setLanguages] = useState(listLanguage)

    const handleLanguage = (d) => {
        setLanguage(d.label)
        setLanguages([
            d,
            ...listLanguage.filter(language => language.label !== d.label)
        ])
        handleLanguageGlobal(d.value)
    }

    const navigate = useNavigate();

    const handleLanguageGlobal = (val) => {
        if (!val) return
        const path = window.location.pathname
        const lastIndex = path.lastIndexOf('/');
        if (val === state.language) return
        updateLanguage(val)
        navigate(val !== 'pt-br' ? `${path.length > 1 ? `${path}` : ''}/${val}` : path.substring(0, lastIndex))
    }

    return (
        <section className='container-language d-none'>
            <div className='container-language-content'>
                <span className="language-group">Grupo Braspress</span>
                <span className="language-group">
                    <Menu menuButton={<MenuButton className="dropdown-title gray200">{language}<img className="arrow-language" src={getImage('icons', 'down.png')} alt='Menu Seletor de Idiomas' /></MenuButton>}>
                        {languages.map((d, index) => (
                            d.label !== language &&

                            <div key={index}>
                                <MenuItem className="dropdown-language-item"
                                    onClick={() => {
                                        handleLanguage(d)
                                    }}
                                >{d.label}
                                </MenuItem>
                                {index + 1 < languages.length && <MenuDivider className="dropdown-divider" />}
                            </div>
                        ))}
                    </Menu>
                </span>
            </div>
        </section>
    )
}

export default LanguageSelector